import React from 'react';
import './FeaturedProducts.css';

import { productsContent } from '../../../constants';
import { Heading, Product } from '../../../components';

const FeaturedProducts = () => {
  // Select specific products by their ID
  const selectedProductIds = [1, 2, 3, 4, 5, 8];
  const selectedProducts = productsContent.filter(product => 
    selectedProductIds.includes(product.id)
  );

  return (
    <section className='products'>

            {/* Section Heading - Updated text */}
      <Heading title={'Featured Templates'} subTitle={'Explore Our Best Designs'} />
      

      <div className='product-container'>
        {selectedProducts.map((product) => (
          <Product key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
}

export default FeaturedProducts;